export const prepareDataForKanbanColumns = (parsedKanbanSettings, applications) => {
  // First sort the kanban settings by order
  const sortedSettings = [...parsedKanbanSettings]?.sort((a, b) => a.Order - b.Order);

  // Then create the columns object
  const columns = {};
  sortedSettings?.forEach((column) => {
    columns[column.Id] = {
      id: column.Id,
      title: column.Title,
      items: [],
      tag: column.Tag,
      visible: column.Visible,
      sendAutomatedEmail: column.SendAutomatedEmail,
      emailSubject: column.EmailSubject,
      emailContent: column.EmailContent,
      order: column.Order,
    };
  });

  // Then assign applications to columns
  applications?.forEach((app) => {
    if (columns[app.applicationStatus]) {
      columns[app.applicationStatus].items.push(app);
    }
  });

  return columns;
};

export const prepareKanbanSettings = (parsedKanbanSettings) =>
  parsedKanbanSettings?.reduce((acc, cur) => {
    acc[cur.Id] = {
      id: cur.Id,
      title: cur.Title,
      tag: cur.Tag,
      visible: localStorage.getItem(cur.Id) === 'false' ? false : true,
    };
    return acc;
  }, {});

export const getKanbanColumnData = (kanbanSettings, applicationStatus) => {
  const parsedKanbanSettings = JSON.parse(kanbanSettings);

  const obj = Object.values(parsedKanbanSettings)?.find((item) => item.id === applicationStatus);
  return obj;
};

export const updateApplicationInKanbanColumns = (columns, updatedApplication) => {
  const newColumns = { ...columns };

  // Remove from all columns (in case status changed)
  Object.keys(newColumns).forEach((colId) => {
    newColumns[colId].items = newColumns[colId].items.filter(
      (app) => app.applicationId !== updatedApplication.applicationId
    );
  });

  // Find the correct column and insert at the correct index if possible
  const newColumnId = updatedApplication.applicationStatus;
  if (newColumns[newColumnId]) {
    // Try to find the correct index by kanbanColumnIndex if available
    let insertIndex = updatedApplication.kanbanColumnIndex;
    if (typeof insertIndex === 'number' && insertIndex >= 0 && insertIndex <= newColumns[newColumnId].items.length) {
      newColumns[newColumnId].items.splice(insertIndex, 0, updatedApplication);
    } else {
      // fallback: push to end
      newColumns[newColumnId].items.push(updatedApplication);
    }
  }

  return newColumns;
};
